module.exports = __webpack_public_path__ + "img/12.58d789d6.jpg";